<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M21.5 3H2.5V18H9.5V22L14.9826 18H21.5L21.5 3Z" stroke="#000" stroke-width="1.5" stroke-linejoin="round"/>
  <path d="M7 8.5H17M7 12.5H13" stroke="#000"/>
</svg>
